// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AckAlarmRequest
 */
export interface AckAlarmRequest {
    /**
     * Human-readable comment recorded with the acknowledge event
     */
    comment?: string;
}

/**
 * Check if a given object implements the AckAlarmRequest interface.
 */
export function instanceOfAckAlarmRequest(value: object): value is AckAlarmRequest {
    return true;
}

export function AckAlarmRequestFromJSON(json: any): AckAlarmRequest {
    return AckAlarmRequestFromJSONTyped(json, false);
}

export function AckAlarmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AckAlarmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function AckAlarmRequestToJSON(json: any): AckAlarmRequest {
    return AckAlarmRequestToJSONTyped(json, false);
}

export function AckAlarmRequestToJSONTyped(value?: AckAlarmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

